import * as React from "react";
import { Loading, NotificationBlock, WidgetWrapper, useAlert } from "uxp/components";
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import { generateIconProp, generateIconPropAsSting } from "../../../common/icon-selector/IconEditor";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { BooleanProperty } from "../../../common/ui-props/BooleanProperty";
import { SimpleTextProperty } from "../../../common/ui-props/SimpleTextProperty";
import { hasValue, replaceWithData } from "../../../../util";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";


const XPRProps: IUIPropertyDefinitionMap = {
    'src': SimpleTextProperty('URL', ''),
    'autoPlay': BooleanProperty('Auto Play', false),
}


const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {

    let uiProps = props?.uiProps || {};
    const [type, setType] = React.useState<string>(null)

    const [loading, setLoading] = React.useState(false)
    let [contextData, setContextData] = React.useState<IContextData>({})
    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    const alerts = useAlert()
    let src = replaceWithData(uiProps?.src?.trim(), contextData)

    React.useEffect(() => {
        console.log('source and type ', src, type);
    }, [src, type])

    React.useEffect(() => {
        processSource()
    }, [src, contextData])

    async function processSource() {
        console.log(src, "src is this")
        if (!hasValue(uiProps.src)) {
            setType(null)
            return
        }

        try {
            console.log("src", "contextData", src, contextData)
            setLoading(true)
            const res = await fetch(src || '')
            const blob = (res && res.status == 200) ? await res.blob() : null

            // Why do we need type?
            setType(blob?.type || null)
        } catch (e) {
            alerts.show('Unable to process the url. Please enter a valid url')
            console.log('unable to process the url. error: ', e);
        }
        finally {
            setLoading(false)
        }
    }

    function render() {
        if (loading) return <NotificationBlock message="Loading your video. Please wait..." />
        if (!hasValue(uiProps.src)) return <NotificationBlock message="Please enter a url or upload a file" />
        if (!hasValue(src) || !hasValue(type)) return <NotificationBlock message="Please enter a valid url or upload a valid video file" />

        return <video controls autoPlay={uiProps?.autoPlay || false} muted loop={false} >
            <source
                src={src}
                // type={type}
            />
        </video>
    }
    return <WidgetWrapper className="uxp-video-card-template" >
        <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'src', 'autoPlay',)}
            contextData={contextData}
        >
            <div className="content-container">
                {render()}
            </div>
        </SelectableItem>
    </WidgetWrapper>
}

registerCardTemplate({
    id: 'video-card',
    name: "Video Card",
    description: 'Video Player card',
    template: XPR,
    icon: generateIconProp('video'),
    complexity: 'easy',
});